import type { BadgeProps } from '@/components/lemmala-design-system/badge/badge'

import type { AvatarColor, AvatarListSize } from './types'

/** Palette keys used to deterministically color name-derived avatars (excludes the neutral defaults). */
export const AVATAR_COLORS: Exclude<AvatarColor, 'default' | 'gray'>[] = [
  'emerald',
  'cyan',
  'purple',
  'pink',
  'amber',
  'lime',
  'sky',
  'violet',
  'rose',
  'teal',
  'fuchsia',
  'orange',
]

export const AVATAR_OVERFLOW_BADGE_SIZE: Record<AvatarListSize, BadgeProps['size']> = {
  'extra-small': 'default',
  small: 'default',
  medium: 'default',
  large: 'large',
}
